import type { WorkspaceTab } from '../types'

const menuRouteKeys = ['menuCode', 'pageCode', 'decorationMode', 'materialScope']

export interface UnavailableMenuRoute {
  requestedMenuCode: string
  search: string
}

export function normalizeUnavailableMenuRoute(search: string, fallbackTab: WorkspaceTab): UnavailableMenuRoute | null {
  const query = new URLSearchParams(search)
  const requestedMenuCode = query.get('menuCode')?.trim() ?? ''
  if (!requestedMenuCode) return null

  for (const key of menuRouteKeys) query.delete(key)
  query.delete('permissionSection')
  query.delete('tab')
  if (fallbackTab !== 'dashboard') query.set('tab', fallbackTab)

  return {
    requestedMenuCode,
    search: query.toString()
  }
}

/** Legacy deep links retain cinema/template context while targeting independent modules. */
export function canonicalCinemaRoute(pathname: string, search: string) {
  const routes: Record<string, string> = {
    '/ticketing/cinema-admin': 'cinema.workbench',
    '/ticketing/seat-map': 'cinema.seats',
    '/ticketing/cinema-provider': 'movie-product.providers'
  }
  const codes: Record<string, string> = {
    'ticketing.cinemaAdmin': 'cinema.workbench',
    'ticketing.seatMap': 'cinema.seats',
    'ticketing.cinemaProvider': 'movie-product.providers'
  }
  const query = new URLSearchParams(search)
  const current = query.get('menuCode') || ''
  const menuCode = current ? codes[current] : routes[pathname.replace(/\/$/, '')]
  if (!menuCode) return null
  query.set('menuCode', menuCode)
  return { pathname: routes[pathname.replace(/\/$/, '')] ? '/' : pathname, search: query.toString() }
}
